import { HttpClient, Result } from "../../../../http/HttpClient.ts";

export interface TermsAndConditionsApiServiceConfig {
  enableNewTermsAndConditionsFlow: boolean;
}

export class TermsAndConditionsApiService {
  private readonly enableNewTermsAndConditionsFlow: boolean;

  constructor(
    private readonly httpClient: HttpClient,
    config: Partial<TermsAndConditionsApiServiceConfig> = {},
  ) {
    this.enableNewTermsAndConditionsFlow =
      config.enableNewTermsAndConditionsFlow ?? false;
  }

  async getTermsAndConditionsStatus(payload: {
    appContext: "insights_agent" | "cla" | "pla";
  }): Result<{
    status: "pending_acceptance" | "accepted" | "acceptance_not_required";
  }> {
    const query = {
      app_context: payload.appContext,
      new_terms_and_conditions_flow: String(
        this.enableNewTermsAndConditionsFlow,
      ),
    };
    console.log("Fetching T&C status with params:", query);
    return this.httpClient.get<{
      status: "pending_acceptance" | "accepted" | "acceptance_not_required";
    }>("/terms-and-conditions/status", query);
  }

  async acceptTermsAndConditions(payload: {
    appContext: "insights_agent" | "cla" | "pla";
  }): Result<{ status: "accepted" }> {
    const query = {
      app_context: payload.appContext,
      new_terms_and_conditions_flow: String(
        this.enableNewTermsAndConditionsFlow,
      ),
    };

    return this.httpClient.post<{ status: "accepted" }>(
      "/terms-and-conditions/accept",
      {},
      query,
    );
  }

  async getLatestTermsAndConditions(payload: {
    appContext: "insights_agent" | "cla" | "pla";
  }): Result<{ content: string }> {
    const query = {
      app_context: payload.appContext,
      new_terms_and_conditions_flow: String(
        this.enableNewTermsAndConditionsFlow,
      ),
    };

    return this.httpClient.get<{ content: string }>(
      "/terms-and-conditions/latest",
      query,
    );
  }
}
